import FavoriteProductContent from './FavoriteProductContent.jsx';

export {FavoriteProductContent}



// WEBPACK FOOTER //
// ./components/users/sub-view/favorite-product-content/index.js